export const panelsQueryKeys = {
  supportCategories: ['support', 'categories'] as const,
  supportAttachmentLimits: ['support', 'attachments', 'limits'] as const,
}
